import { Injectable } from '@angular/core';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { environment } from 'src/environments/environment';
import { Channel } from '../models/channel.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LineNotificationService {

  private lineServiceUrl: string = environment.endpointBackend + '/api/line';
  constructor(
    private http: HttpClient
  ) { }

  sendNotification(payload: Channel): Observable<PayloadResponse<null>> {
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/put/message/notification', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }
  sendNotificationWithTemplate(payload: Channel): Observable<PayloadResponse<null>> {
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/put/message/notificationWithTemplate', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }
}
